<app-solution-subscribe-pc
  *ngIf="windowWidth > 1200"
></app-solution-subscribe-pc>
<app-solution-subscribe-tablet
  *ngIf="windowWidth <= 1200 && windowWidth > 767"
></app-solution-subscribe-tablet>
<app-solution-subscribe-mobile
  *ngIf="windowWidth <= 767"
></app-solution-subscribe-mobile>
